export var isErrorResponse = function (response) { return (response === null || response === void 0 ? void 0 : response.error) !== undefined; };
